/**
 * Reusable placeholder box the owner can replace with their asset.
 * The `note` prop is shown ON the placeholder so the user always knows
 * exactly what to put there (image, video, logo, description, link etc).
 */
export default function Placeholder({
  note,
  aspect = "16/9",
  className = "",
  minHeight,
  rounded = "1rem",
  testId,
}) {
  return (
    <div
      data-testid={testId}
      className={`ee-placeholder ${className}`}
      style={{
        aspectRatio: minHeight ? undefined : aspect,
        minHeight,
        borderRadius: rounded,
      }}
    >
      <span style={{ maxWidth: "90%", lineHeight: 1.5 }}>{note}</span>
    </div>
  );
}
